<template>
  <div class="flex column" :class="classList">
    <div v-for="item in itemsToPresent" :key="item.name" class="item capitalize-first-letter">
      <a :href="item.rule.externalTechniqueUrl" target="_blank" rel="noreferrer">{{ item.iocTactic }}</a>
    </div>
    <el-tooltip v-if="remainingItems.length" class="mitre-tactic-tooltip" effect="dark" :placement="placement"
                popper-class="mitre-tactic-tooltip-popper">
      <div slot="content" v-for="item in remainingItems" :key="item.name"
           class="item remaining-technique capitalize-first-letter">
        <a :href="item.rule.externalTechniqueUrl" target="_blank" rel="noreferrer">{{ item.iocTactic }}</a>
      </div>
      <div class="item remaining-technique-length capitalize-first-letter">{{ `+${remainingItems.length}` }}</div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: "TrailIocList",
  props: {
    iocList: {
      type: Array,
      default: () => []
    },
    itemsShown: {
      type: Number,
      default: () => 2
    },
    placement: {
      type: String,
      default: () => "right"
    },
    classList: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      itemsToPresent: [],
      remainingItems: []
    }
  },
  watch: {
    iocList: {
      handler(newValue) {
        const uniqueIocList = newValue.filter(item => item.iocTactic).reduce((unique, item) => {
          if (!unique.some(uniqueItem => uniqueItem.iocTactic === item.iocTactic)) {
            unique.push(item);
          }
          return unique;
        }, []);

        this.itemsToPresent = uniqueIocList.slice(0, this.itemsShown).map(item => {
          return {...item, iocTactic: item.iocTactic.replace("_", " ")};
        });
        this.remainingItems = uniqueIocList.slice(this.itemsShown).map(item => {
          return {...item, iocTactic: item.iocTactic.replace("_", " ")};
        });
      },
      immediate: true
    }
  }
};
</script>
<style scoped>
@import "assets/styles/_variables.css";

.remaining-technique-length {
  color: #1a90fa;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/TrailIocList.vue